import ProjectMap from './ProjectMap';
import { onDomReady } from "../../components/dynamic/observer";

onDomReady(() => {
  document.querySelectorAll('[data-project-map]').forEach((element) => {
    new ProjectMap(element, {});
  });
});